import BaseModel from '@/bundles/App/models/BaseModel';
import { Nullable } from '@/utils/types';
import { ICreatedUpdatedBy } from '@/bundles/App/interfaces/ICreatedUpdatedBy';
import { ExtractionSourceEnum } from '@/bundles/Common/types/extractionSource';
import {
  ILeaseIngestion,
  ILeaseIngestionDocumentRef,
  ILeaseIngestionStatusHistoryItem,
  ILeaseExtraction,
  ILeaseIngestionEditDelta,
  ILeaseIngestionCreatedIds,
  LeaseIngestionStatusEnum,
} from '@/bundles/LeaseIngestion/types';

export default class LeaseIngestion extends BaseModel implements ILeaseIngestion {
  _key: string;
  _id: string;
  _rev: string;
  accountId: number;
  uploadedBy: ICreatedUpdatedBy;
  documentRef: ILeaseIngestionDocumentRef;
  abstractRef?: Nullable<ILeaseIngestionDocumentRef>;
  status: LeaseIngestionStatusEnum;
  statusHistory: ILeaseIngestionStatusHistoryItem[];
  originalExtraction: Nullable<ILeaseExtraction>;
  extraction: Nullable<ILeaseExtraction>;
  editDelta: Nullable<ILeaseIngestionEditDelta>;
  extractionError: Nullable<string>;
  createdIds: Nullable<ILeaseIngestionCreatedIds>;
  reviewComment?: string;
  extractionSource?: ExtractionSourceEnum;
  active: boolean;

  constructor (payload: ILeaseIngestion) {
    super(payload);
    this._key = payload._key;
    this._id = payload._id;
    this._rev = payload._rev;
    this.accountId = payload.accountId;
    this.uploadedBy = payload.uploadedBy;
    this.documentRef = payload.documentRef;
    this.abstractRef = payload.abstractRef ?? null;
    this.status = payload.status;
    this.statusHistory = payload.statusHistory ?? [];
    this.originalExtraction = payload.originalExtraction ?? null;
    this.extraction = payload.extraction ?? null;
    this.editDelta = payload.editDelta ?? null;
    this.extractionError = payload.extractionError ?? null;
    this.createdIds = payload.createdIds ?? null;
    this.reviewComment = payload.reviewComment;
    this.extractionSource = payload.extractionSource;
    this.active = payload.active;
  }
}
